/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {calendarController as ɵb} from './calendar.module';
export {CALENDAR_COMPONENTS as ɵa} from './components';
export {CalendarService as ɵc} from './services/calendar.service';